import merge from 'lodash.merge';

const config = {
  env: process.env.REACT_APP_ENV || 'development',
};

switch (config.env) {
  case 'development':
    // eslint-disable-next-line import/no-dynamic-require
    merge(config, require(`config/development`).default);
    break;
  case 'staging':
    // eslint-disable-next-line import/no-dynamic-require
    merge(config, require(`config/staging`).default);
    break;
  case 'production':
    // eslint-disable-next-line import/no-dynamic-require
    merge(config, require(`config/production`).default);
    break;
  default:
    // eslint-disable-next-line import/no-dynamic-require
    merge(config, require(`config/development`).default);
    break;
}

export default config;
